import { coverDeep1, coverDeep2, deepArchiveItems } from "@/mocks/archive";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

const COVER: Record<string, string> = {
  coverDeep1,
  coverDeep2,
};

export default function DeepArchive() {
  return (
    <section id="deep" className="border-t border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <Reveal>
          <SectionHead
            kicker="长文重构 · 逐格复盘"
            title="国产黑料深扒档案"
            desc="短讯看个大概，真要补全来龙去脉就翻档案——把公开片段、公告与发言摆回同一条时间轴，结论自己看。"
          />
        </Reveal>

        <div className="grid gap-6 lg:grid-cols-2 md:gap-7">
          {deepArchiveItems.map((d, i) => (
            <Reveal key={d.no} delay={i * 100}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300">
                <div className="relative aspect-[5/3] overflow-hidden">
                  <img
                    src={COVER[d.cover]}
                    alt={d.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 inline-flex h-7 items-center rounded-md bg-foreground-950/85 px-2.5 text-xs font-bold text-background-50 backdrop-blur-sm">
                    {d.kind}
                  </span>
                  <span className="absolute right-4 top-4 inline-flex items-center gap-1 rounded-md bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-foreground-700 backdrop-blur-sm">
                    <i className="ri-time-line"></i>
                    {d.minutes}
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-5 md:p-7">
                  <div className="flex items-center gap-2 text-xs text-foreground-400">
                    <span className="font-semibold tracking-widest text-primary-600">{d.no}</span>
                    <span className="h-1 w-1 rounded-full bg-background-300"></span>
                    <span>完整档案</span>
                  </div>
                  <h5 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                    {d.title}
                  </h5>
                  <p className="mt-2.5 flex-1 text-sm leading-6 text-foreground-600">{d.lead}</p>

                  <div className="mt-5 flex flex-wrap items-center gap-2 border-t border-background-200/70 pt-4">
                    {d.points.map((p) => (
                      <span key={p} className="rounded-md bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-900">
                        {p}
                      </span>
                    ))}
                    <span className="ml-auto inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-700">
                      展开整档
                      <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}